import React from "react";
import { Link } from "react-router-dom";
import Card from "../../shared/Card";

export default function ContactBanner(props) {

  const formatPhone = (phoneNo) => {
    let s2 = ("" + phoneNo).replace(/\D/g, "");
    var m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
    return !m ? null : "(" + m[1] + ") " + m[2] + "-" + m[3];
  }

  const contact = (
    <Card
      cardType="default"
      cardHeader="Contact"
      headerColor="#046B99"
      headerTextColor="white"
      cardBody={
        <div className="contact-card">
          <div className="banner-title pl-0">{props.CONTACT_NAME}</div>
          <div className="">{props.CONTACT_ST1}</div>
          <div className="">{props.CONTACT_CITY},  {props.CONTACT_STATE} {props.CONTACT_ZIP}</div>
          <div className="">{formatPhone(props.CONTACT_PHONE)}</div>
          {props.CONTACT_EMAIL !== null ?
            <Link to="#" onClick={(e) => {
              window.location = `mailto:${props.CONTACT_EMAIL}`;
              e.preventDefault();
            }}>
              {props.CONTACT_EMAIL}
            </Link>
            : null}
        </div>
      }
      cardColor="white"
    />
  );

  return <div>{contact}</div>;
}

